// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@steiner/XDL/types";

export default {
    primary: {
        main: "#00609C",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#FFC72B",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#CCCCCC",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#383D40",
        ui7: "#000000",
        ui8: "#00609C",
        ui9: "#03A7E7",
        ui10: "#043F67",
        ui11: "#FFC72B",
        ui12: "#ECAE00",
        ui13: "#D0A121",
        ui14: "#F2F7FA",
        ui15: "#E8F0FE",
        ui16: "#262626",
        ui17: "#E2EFF7",
        ui18: "#004773",
        white: "#FFFFFF",
        black: "#000000",
        pieChart: "#00C49F",
        pieChart2: "#0088FE",
    },
    text: {
        main: "#383D40",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#00609C",
        heading: "#262626",
    },
    success: {
        main: "#5AA700",
        contrast: "#FFFFFF",
        light: "#D9F2E7",
    },
    danger: {
        main: "#E0182D",
        contrast: "#FFFFFF",
        light: "#FBDBE5",
    },
    warning: {
        main: "#DAA91C",
        contrast: "#FFFFFF",
        light: "#FDF9DE",
    },
    info: {
        main: "#00A1DF",
        contrast: "#FFFFFF",
        light: "#DDEEF8",
    },
} as xBaseTheme["colors"];
